import jQuery from "jquery";

jQuery(function ($) {
  addAccessibilitySubmenuButtons();
  accessibleMobileMenuHandler();
  showMenuOnScrollTop();
  addTopBarsSizeCSSVariable();
  window.addEventListener("resize", addTopBarsSizeCSSVariable);

  // Ajoute des boutons accessibles qui ouvrent les sous-menu mobile
  // Code inspiré de W3.org et converti en jquery: https://www.w3.org/WAI/tutorials/menus/flyout/
  function addAccessibilitySubmenuButtons() {
    const menuItems = $(".main-navigation li.menu-item-has-children");
    menuItems.each(function (index, element) {
      const link = $(element).children("a");
      const button =
        '<button class="submenu-mobile-button" type="button" aria-haspopup="true" aria-expanded="false">' +
        '<svg aria-hidden="true">' +
        '<use xlink:href="/wp-content/themes/angak/assets/images/spritemap.svg#CaretDownBold" />' +
        "</svg>" +
        '<span class="screen-reader-text">ouvrir le sous-menu de “' +
        link.text() +
        "”</span></button>";
      link.after(button);
      $(element)
        .children("button")
        .on("click", function (event) {
          const parentLi = $(element);
          if (parentLi.hasClass("is-opened")) {
            parentLi.removeClass("is-opened");
            link.attr("aria-expanded", "false");
            $(this).attr("aria-expanded", "false");
          } else {
            parentLi.addClass("is-opened");
            link.attr("aria-expanded", "true");
            $(this).attr("aria-expanded", "true");
          }
          event.preventDefault();
        });
    });
  }

  // Fonction qui gère l'ouverture du menu mobile de façon accessible
  function accessibleMobileMenuHandler() {
    const toggleButton = $(".main-navigation #toggle-menu-button");
    const navigationContainer = $(".main-navigation .main-navigation-ul");
    const anchorLinks = navigationContainer.find("a[href='#finder']");
    toggleButton.on("click", function (event) {
      toggleMenu(toggleButton, navigationContainer);
      event.preventDefault();
    });
    navigationContainer.find("a,button").on("keydown", function (event) {
      if (event.which == 27 && toggleButton.attr("aria-expanded") == "true") {
        toggleMenu(toggleButton, navigationContainer);
        event.preventDefault();
      }
    });
    if (anchorLinks.length) {
      anchorLinks.on("click", function (event) {
        toggleMenu(toggleButton, navigationContainer);
      });
    }
  }

  function toggleMenu(toggleButton, navigationContainer) {
    const body = $("body");
    const isOpen = toggleButton.attr("aria-expanded") == "true" ? true : false;
    if (isOpen) {
      toggleButton.attr("aria-expanded", "false");
      navigationContainer.removeClass("is-opened");
      body.removeClass("mobile-menu-opened");
    } else {
      toggleButton.attr("aria-expanded", "true");
      navigationContainer.addClass("is-opened");
      body.addClass("mobile-menu-opened");
    }
  }
  // Permet d'afficher le menu au scroll vers le haut.
  function showMenuOnScrollTop() {
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $(".header-container").outerHeight();
    $(window).on("scroll", function (event) {
      didScroll = true;
    });

    setInterval(function () {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);

    function hasScrolled() {
      var st = $(window).scrollTop();
      // Make sure they scroll more than delta
      if (Math.abs(lastScrollTop - st) <= delta) return;

      if (st < navbarHeight) {
        $(".header").removeClass("is-smaller");
      } else {
        $(".header").addClass("is-smaller");
      }
      setTimeout(function () {
        addTopBarsSizeCSSVariable(null, true);
      }, 305);

      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $(".header").removeClass("nav-down").addClass("nav-up");
      } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
          $(".header").removeClass("nav-up").addClass("nav-down");
        }
      }

      lastScrollTop = st;
    }
  }
  // Refresh all css variables concerning navigation (on scroll, resize)
  // The event parameter is not used but we need it to add a parameter to the function
  // because this function is also called as an addEventListener callback (which add event as first parameter)
  function addTopBarsSizeCSSVariable(event, onScroll = false) {
    const adminbar = $("#wpadminbar");
    const topbar = $(".topbar-container");
    const header = $(".header-container");
    const adminbarHeight = adminbar.height() ? adminbar.height() : 0;
    const topbarHeight = topbar.height() ? topbar.height() : 0;
    const headerHeight = header.height() ? header.height() : 0;
    const dropdownMaxHeight = $(window).height() - headerHeight - 10;
    document.documentElement.style.setProperty(
      "--adminbar-height",
      Math.ceil(adminbarHeight) + "px"
    );
    document.documentElement.style.setProperty(
      "--topbar-height",
      Math.ceil(topbarHeight) + "px"
    );
    document.documentElement.style.setProperty(
      "--dropdown-maxheight",
      Math.ceil(dropdownMaxHeight) + "px"
    );
    document.documentElement.style.setProperty(
      "--header-height-dynamic",
      Math.ceil(headerHeight) + "px"
    );
    if (!onScroll) {
      document.documentElement.style.setProperty(
        "--header-height",
        Math.ceil(headerHeight) + "px"
      );
    }
  }
});
